import { AdTemplateSerializer } from "@models/serializers/adTemplateSerializer";
import { httpRequest } from "../../../shared/services/http";
import { AdTemplate } from "@models/AdTemplate.model";

export class CommandDupeTemplateAsChild {
  async run(parentId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ad_templates/${parentId}/duplicate/`;
    try {
      const response = await httpRequest(url, {
        method: "POST",
        body: {},
      }).catch((err) => console.log(err));
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): AdTemplate {
    return new AdTemplateSerializer().deserialize(data);
  }
}
